exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flightsTable_slotsStatus[data-v-787885d2]{width:95px;justify-content:center}.test p[data-v-787885d2]{margin-bottom:0!important}.rowWasEdited[data-v-787885d2]{border:2px solid #ab3b7c;padding:2px}", ""]);

// exports
